import { render, staticRenderFns } from "./Create-Opportunity.vue?vue&type=template&id=613a2a97"
import script from "./Create-Opportunity.vue?vue&type=script&lang=js"
export * from "./Create-Opportunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports